import { filter } from "@suse-o11y/filter";
import { isPresent } from "@suse-o11y/is-present";
import { z } from "zod";

export const dashboardStaticListVariableSchema = z.object({
	values: z
		.array(
			z
				.object({
					value: z.string().min(1, "Value cannot be empty"),
					label: z
						.string()
						.transform((input) => input.trim() || undefined)
						.catch(undefined),
				})
				.optional()
				.catch(undefined),
		)
		.transform(filter(isPresent))
		.catch([]),
});

export type DashboardStaticListVariable = z.infer<typeof dashboardStaticListVariableSchema>;
